import { TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule, ModalsModule } from '@wix/domains-search-suite';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
export const MobileNotSupportedTld = _ref => {
  let domainName = _ref.domainName,
    datahook = _ref.datahook;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  const availableExtensionsModal = ModalsModule.internals.domainsSharedModalsController.availableExtensionsModal;
  const _parseDomain = parseDomain(domainName ?? ''),
    tld = _parseDomain.tld,
    formattedInput = _parseDomain.formattedInput;
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook,
    transparent: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.unavailable_domain",
    values: {
      domainName: formattedInput,
      tld: `.${tld}`
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: () => availableExtensionsModal.show({
        variant: 'list'
      })
    })]
  }));
};
//# sourceMappingURL=MobileNotSupportedTld.js.map